import React from "react";
import { Flex, FlexProps, useControlled } from "../..";
import { RadioGroupContext } from "./RadioGroupContext";

export type RadioGroupProps = {
  children?: React.ReactNode;
  value?: string;
  defaultValue?: string;
  name: string;
  onChange?: React.FormEventHandler<HTMLInputElement>;
} & FlexProps;

export const RadioGroup: React.FC<RadioGroupProps> = ({
  children,
  value,
  defaultValue = "",
  name,
  onChange,
  ...props
}) => {
  const [innerValue, setInnerValue] = useControlled<string>(
    defaultValue,
    value
  );
  const handleChange: React.FormEventHandler<HTMLInputElement> = (e) => {
    setInnerValue(e.currentTarget.value);

    if (onChange) {
      onChange(e);
    }
  };
  return (
    <RadioGroupContext.Provider
      value={{ name, onChange: handleChange, value: innerValue }}
    >
      <Flex role="radiogroup" {...props}>
        {children}
      </Flex>
    </RadioGroupContext.Provider>
  );
};

RadioGroup.displayName = "RadioGroup";

export default RadioGroup;
